<template>
  <div :class="b()">
    <span class="invisible">
      {{ loadingMessage }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'e-progress',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Defines a fallback message. "e-progress.loading" is used by default
       */
      message: {
        type: String,
        default: null, // Translation can not be set here because it will not be computed
      },
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Returns a readable loading message.
       *
       * @returns {String}
       */
      loadingMessage() {
        return this.message || this.$i18n.t('e-progress.loading');
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  // @use '@/setup/scss/variables';
  // @use '@/setup/scss/mixins' as *;
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  @keyframes e-progress-spin {
    0% {
      background: functions.get-theme-var('color-primary-1');
      transform: rotate(0deg) scale(1);
    }

    25% {
      transform: rotate(90deg) scale(2);
    }

    50% {
      border-radius: 50%;
      background: functions.get-theme-var('color-secondary-4');
      transform: rotate(180deg) scale(1);
    }

    75% {
      transform: rotate(270deg) scale(2);
    }

    100% {
      background: functions.get-theme-var('color-primary-1');
      transform: rotate(359deg);
    }
  }

  .e-progress {
    display: flex;
    justify-content: center;
    align-items: center;
    width: functions.rem(80px);
    height: functions.rem(80px);

    &::before {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      animation: e-progress-spin 2s ease-in-out infinite;
    }
  }
</style>
